// ログイン成功後に戻る先を sessionStorage に退避するキー（#548）。
//
// 認証必須ページが、長い URL（例: `/connect` の OAuth パラメータは `redirect_uri` を
// 入れ子で含み query 連結が壊れやすい）を query で渡さずに保持するために使う。
// `useAuthFlow` がサインイン成功後にこのキーを消費して元のページへ戻す。
export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'

/**
 * ログイン導線に入る直前に呼ぶ。戻ってきてほしい URL（通常は現在のフルパス）を退避する。
 * #751 のサインイン CTA（♥/★ を押した未ログインユーザーを /signin・/signup へ送る）が、
 * 認証後に元の画面へ戻すために使う。#548 の /connect と同じ sessionStorage 機構。
 */
export function setPostLoginRedirect(url: string): void {
  if (typeof window === 'undefined') return
  window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, url)
}

/**
 * 戻り先として受け入れてよい URL か（#822）。
 *
 * 検証は **消費側 1 箇所**に置く。setter の呼び出し元は #548 / #751 / #795 / #822 と
 * 増えており、今後足す人が検証を書き忘れても、ここを通る限り安全側に倒れるため。
 *
 * - `/` 始まりのみ（外部オリジンへ飛ばさない）
 * - `//` 始まりは弾く（protocol-relative URL は `//evil.example` で外部に飛ぶ）
 * - `/signin` / `/signup` 自身は弾く（認証直後に認証画面へ戻すループを作らない）
 */
export function isSafePostLoginRedirect(url: string): boolean {
  if (!url.startsWith('/') || url.startsWith('//')) return false
  const path = url.split(/[?#]/)[0]!
  return path !== '/signin' && path !== '/signup'
}

/**
 * ログイン成功後に呼ぶ。退避された戻り先 URL があれば取り出して消費する（無ければ null）。
 * メール/PW（useAuthFlow）と Google（auth/google/callback）の両経路から使う。
 * 受け入れられない値だった場合も **必ず消費して** null を返す（次のログインに持ち越さない）。
 */
export function consumePostLoginRedirect(): string | null {
  if (typeof window === 'undefined') return null
  const back = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
  if (back) window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  if (!back || !isSafePostLoginRedirect(back)) return null
  return back
}
